export default {
  Auth: {
    Cognito: {
      userPoolId: process.env.ADMIN_AUDIT_USER_POOL,
      userPoolClientId: process.env.ADMIN_AUDIT_CLIENT
    }
  }
};
